module.exports = __webpack_public_path__ + "img/stone_copper_ba_list.dcbec626.jpg";